import tree from './images/tree.png';

export const TreeShadow = <ellipse cx={12} cy={-4} rx={35} ry={18} opacity={0.1} />;

export const TreeTopSprite = <image x={-177} y={-1029} href={tree} />;

export const TreeBottomSprite = <><path d="M-7.06-79.33C-7.54-64.8-8-53.28-8.35-38.75A255.31,255.31,0,0,0-7.25-4.07C-6.23,5.05-.84,7.71,5.9,4.4,8.54,3.1,11.15,1.69,13.82.52,28.94-6.12,33.54-19,34.28-35.57c.64-14.37,0-28.82-.06-43.24Z" fill="#754c24" /><path d="M34.16-80c0,2.49-9.18,5-20.5,5s-20.5-2-20.5-4.5S2.34-84,13.66-84,34.16-82.51,34.16-80Z" fill="#F4B25C" /></>;
